import {
	Container,
	ContainerPadding,
	TokenTextAppearance,
	TextAlignment,
	Text,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { ErrorImage } from './assets/error-image';
import { StyledErrorContainer, StyledSVGContainer } from './ui/loading-manager-styles';

export const ErrorComponent = () => {
	return (
		<StyledErrorContainer>
			<StyledSVGContainer>
				<ErrorImage />
			</StyledSVGContainer>
			<Container padding={{ bottom: ContainerPadding.static150 }}>
				<Text appearance={TokenTextAppearance.headline300}>Uy, algo no está funcionando.</Text>
			</Container>

			<Text appearance={TokenTextAppearance.headline300} textAlign={TextAlignment.center} bold>
				Por favor, inténtalo de nuevo más tarde.
			</Text>
		</StyledErrorContainer>
	);
};
